import styled from "styled-components";

export const GeneralTitle = styled.div`
  font-size: ${props => props.theme.fontSize.fs16};
  font-weight: bold;
  margin-bottom: ${props => props.theme.spacer.m32};
`;

export const LableTitle = styled.div`
  font-size: ${props => props.theme.fontSize.fs12};
  height: 100%;
`;